import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  clientId: "98BC3EB2-DAE8-4472-A0B4-524B94225EF4",
  apiUris: {
    companyApiUri: "https://company-design.promob.com/api",
    chartsApiUri: "https://summary-eu-connect.promob.com/api",
    projectsApiUri: "https://api-eu-connect.promob.com/api",
    identitiesApiUri: "https://api.promob.com/v1/Identities",
    connectSettings: "https://func-connect-settings-prod-eastus2-001.azurewebsites.net/api"
  }
};
